import { handleButtonTracking } from "./button-tracking";

export const handleScroll = async (hash) => {
  const element = document.getElementById(hash);
  console.log(hash);
  if (element) {
    const offset = 25;

    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    const targetPosition = elementPosition - offset;

    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
};

export const handleHeaderClick = async (router, hash) => {
  handleButtonTracking(`user_clicked_${hash}_nav`);
  await router.push(`/#${hash}`, { scroll: false });
  if (window.location.pathname !== "/") window.location.href = `/#${hash}`;
  const element = document.getElementById(hash);
  if (element) {
    const offset = 25;

    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    const targetPosition = elementPosition - offset;

    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
};

export const handleBlogScroll = async (hash) => {
  const element = document.getElementById(hash);
  if (element) {
    const offset = 75;

    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    const targetPosition = elementPosition - offset;

    window.scrollTo({ top: targetPosition, behavior: "smooth" });
  }
};
